export default {
  "radio": "_radio_lkyen3"
};